angular
  .module('jrTracking', ['jrConfig', 'jrUtil'])
  .factory('GoogleTagManagerTrackingService', [
    'emailFormatterService',
    function (emailFormatterService) {
      function dataLayerPush(eventName, modalType, modalPopupPolicy, socialSource, email) {
        return function () {
          dataLayer.push({
            event: eventName,
            modalType: !modalType ? '' : modalType,
            modalPopupPolicy: !modalPopupPolicy ? '' : modalPopupPolicy,
            socialSource: !socialSource ? '' : socialSource,
            emailDomain: !email ? '' : emailFormatterService.getDomain(email),
          });
        };
      }

      return {
        trackFavouriteJobsProposal: dataLayerPush('proposal.favourite', 'favourite'),
        trackAutoProposal(modalPopupPolicy) {
          dataLayerPush('proposal.auto', 'auto', modalPopupPolicy)();
        },
        trackInlineProposal: dataLayerPush('proposal.inline', 'inline'),
        trackFavouriteJobsSubscription: dataLayerPush('subscription.favourite', 'manual'),
        trackAutoSubscription(email) {
          dataLayerPush('subscription.auto', 'auto', '', '', email)();
        },
        trackInlineSubscription(email) {
          dataLayerPush('subscription.inline', 'inline', '', '', email)();
        },
        trackAddMoreStatement: dataLayerPush('add.statement', 'statement'),
        trackRightsideSubscription(email) {
          dataLayerPush('subscription.rightside', 'rightside', '', '', email)();
        },
        trackRightsideBottomSubscription(email) {
          dataLayerPush('subscription.rightsideBottom', 'rightside', '', '', email)();
        },
        trackSocialAutoSubscription(socialSource, email) {
          dataLayerPush('subscription.social.auto', 'auto', '', socialSource, email)();
        },
        trackSignup(email) {
          dataLayerPush('signup.manual', 'signup', '', '', email)();
        },
        trackLogin: dataLayerPush('login.manual'),
        trackFacebookLogin: dataLayerPush('login.facebook'),
        trackGoogleLogin: dataLayerPush('login.google'),
        trackLinkedinLogin: dataLayerPush('login.linkedin'),
        trackRecoverPassword: dataLayerPush('recover.password'),
        trackResetPassword: dataLayerPush('reset.password'),
        trackChangePassword: dataLayerPush('change.password'),
        tracksetPassword: dataLayerPush('set.password'),
      };
    },
  ])
  .factory('jtagService', [
    '$window',
    function ($window) {
      return {
        track(eventName, event, opts, href) {
          event.preventDefault();
          jtag('event', eventName, opts);

          $window.location.assign(href);
        },
      };
    },
  ])
  .directive('jtagAnalytics', [
    'jtagService',
    function (jtagService) {
      return {
        link(scope, elem, attrs) {
          Object.keys(jtagService).forEach((key) => {
            scope[key] = jtagService[key];
          });
        },
      };
    },
  ]);

if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    const el = this;
    let ancestor = this;
    if (!document.documentElement.contains(el)) {
      return null;
    }
    do {
      if (ancestor.matches(s)) {
        return ancestor;
      }
      ancestor = ancestor.parentElement;
    } while (ancestor !== null);
    return null;
  };
}
